import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import ItemMiddleware from "../../../../middleware/modules/master/item";
import ItemView from "../../../../components/modules/master/item/view";
import SellingMiddleware from "../../../../middleware/modules/sales/selling";
import SellingView from "../../../../components/modules/sales/selling/view";

const mapStateToProps = ({ auth, selling }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: selling.isProcessing,
  isError: selling.isError,
  errorMessage: selling.errorMessage,
  dataUpdate: selling.single,
  isSuccess: selling.isSuccess,
  isReset: selling.isReset,
  isNewRecord: selling.isNewRecord,
  onSubmit: selling.onSubmit,
  helperSelling: selling.helperSelling,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => SellingMiddleware.reset(),
      getData: (id) => SellingMiddleware.getViewSelling(id),
    },
    dispatch
  );
};
class SellingViewContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
  }

  // getData() {
  //   return this.props.showOne(this.props.dataID);
  // }

  // close() {
  //   this.props.closeModal();
  // }
  // submitForm() {
  //   const { search, isNewRecord, dataUpdate } = this.props;
  //   var form = this.form.current.runSubmit();
  //   if (isNewRecord) {
  //     this.props.new(form, search);
  //   } else {
  //     this.props.update(dataUpdate.id, form, search);
  //   }
  // }

  UNSAFE_componentWillMount() {
    this.props.getData(this.props.id);
    // this.props.getDetail(this.props.id);
  }

  render() {
    const {
      onSubmit,
      showModal,
      titleModal,
      dataUpdate,
    } = this.props;
    return (
      <>
       <SellingView 
          {...this.props}
       />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SellingViewContainer);
